import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { wait } from "../../../../utils/fn";
import { processSmsStatus } from "../logic/utils";
import { getIsSmsStatusReceived } from "./utils";
export var getCommonSubmitPayment = function getCommonSubmitPayment(_ref) {
  var submit = _ref.submit,
    pollStatus = _ref.pollStatus,
    getContent = _ref.getContent;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var _getContent, delay, _yield$submit, status, orderId, isSmsStatusReceived;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getContent = getContent(), delay = _getContent.requestSettings.default.delay;
            _context.next = 3;
            return submit();
          case 3:
            _yield$submit = _context.sent;
            status = _yield$submit.status;
            orderId = _yield$submit.orderId;
            isSmsStatusReceived = status && getIsSmsStatusReceived(status);
            if (!isSmsStatusReceived) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", processSmsStatus(setState, status));
          case 9:
            if (orderId) {
              _context.next = 11;
              break;
            }
            throw new Error('no orderId received');
          case 11:
            _context.next = 13;
            return wait(delay);
          case 13:
            _context.next = 15;
            return pollStatus(orderId);
          case 15:
            return _context.abrupt("return", _context.sent);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};